import React from 'react'

import { WelcomeMessage } from '../WelcomeMessage/WelcomeMessage'
import { useAvailability } from '../../utils/availability'
import { Notification } from '../Notification/Notification'
import { NotInDeliveryAreaWarning } from '../NotInDeliveryAreaWarning/NotInDeliveryAreaWarning'
import { useGetCart } from '../CartQuery/CartQuery'

export const RestaurantNotification = () => {
  let { info } = useGetCart()
  if (!info) { // use default if info is null
    info = []
  }
  const { loading: availabilityLoading, orderingAvailable } = useAvailability()
  const showAvailabilityNotification = !availabilityLoading && !orderingAvailable

  return (
    <div>
      <WelcomeMessage />
      {orderingAvailable && <NotInDeliveryAreaWarning padTop severity='warning' isActionable />}
      {showAvailabilityNotification &&
      <Notification padTop isCloseable> Online ordering is currently not available but feel free to browse our menu. </Notification>
      }

      {info.length > 0 && info.map(({ code, message }) => (
        <div key={code}>
          <Notification padTop isCloseable>
            {message}
          </Notification>
        </div>
      ))}
    </div>
  )
}
